import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from './store';
import { Gateway, GatewayPermissionItem } from 'features/gateways/types/gateway.types';

type GatewayType = {
    create: boolean;
    activeGateway: Gateway | undefined;
    gatewayPermissionList: GatewayPermissionItem[] | undefined;
};

const initialState: GatewayType = {
    create: false,
    activeGateway: undefined,
    gatewayPermissionList: undefined,
};

export const GatewaySlice = createSlice({
    name: 'gateway',
    initialState,
    reducers: {
        visibleCreateDialog: (state: GatewayType) => {
            state.create = !state.create;
        },
        setActiveGateway: (
            state: GatewayType,
            action: PayloadAction<Gateway | undefined>,
        ) => {
            state.activeGateway = action.payload;
        },
        setGatewayPermissionList: (
            state: GatewayType,
            action: PayloadAction<GatewayPermissionItem[] | undefined>,
        ) => {
            state.gatewayPermissionList = action.payload;
        },
    },
});

export const gatewayCreateState = (state: RootState) => state.gateway.create;
export const activeGateway = (state: RootState) => state.gateway.activeGateway;
export const gatewayPermissionList = (state: RootState) =>
    state.gateway.gatewayPermissionList;

export const {
    visibleCreateDialog,
    setActiveGateway,
    setGatewayPermissionList,
} = GatewaySlice.actions;

export default GatewaySlice.reducer;
